<p-table [value]="items()" size="small" [rowHover]="true" (onSort)="sort($event)" [lazy]="true" [sortField]="sorting().orderByClause" [sortOrder]="sorting().orderDirection === 'asc' ? 1 : -1">
  <ng-template pTemplate="header">
    <tr>
      @if (!minimal()) {
        <th pSortableColumn="order_code">Commessa <p-sortIcon field="order_code" /></th>
        <th pSortableColumn="position_code">Posizione <p-sortIcon field="position_code" /></th>
        <th pSortableColumn="position_expire_date">Scadenza posizione <p-sortIcon field="position_expire_date" /></th>
      }
      <th pSortableColumn="equipment_short_description">Materiale  <p-sortIcon field="equipment_short_description" /></th>
      <th pSortableColumn="quantity">Quantità <p-sortIcon field="quantity" /></th>
      <th pSortableColumn="supplier_short_description">Fornitore <p-sortIcon field="supplier_short_description" /></th>
      <th pSortableColumn="state_id">Stato <p-sortIcon field="state_id" /></th>
      @if (minimal()) {
        <th>Note</th>
        <th style="width: 4rem"></th>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-req>
    <tr (click)="onSelect.emit(req)" class="cursor-pointer">
      @if (!minimal()) {
        <td>
          <div class="font-bold">{{req.orderCode}}</div>
          <div class="text-sm">{{req.orderShortDescription}}</div>
        </td>
        <td>
          <div class="font-bold">{{req.positionCode}}</div>
          <div class="text-sm">{{req.positionShortDescription}}</div>
        </td>
        <td>{{req.positionExpireDate | date:'dd/MM/yyyy'}}</td>
      }

      <td>{{ minimal() ? organizationStore.getEquipment(req.equipmentId)()?.shortDescription : req.equipmentShortDescription }}</td>
      <td>{{ req.quantity +' '+ organizationStore.getEquipment(req.equipmentId)()?.unit }}</td>
      <td>{{ req.supplierShortDescription || (req.supplierId ? organizationStore.getSupplier(req.supplierId)()?.shortDescription : '-') }}</td>
      <td><p-tag [value]="getRequestStatusDescription(req.stateId)" [severity]="getRequestStatusSeverity(req.stateId)"></p-tag></td>

      @if (minimal()) {
        <td>{{ req.description }} </td>
        <td class="p-0">
          @if(req.stateId === 1) {
            <p-button icon="pi pi-trash" severity="danger" size="small" [rounded]="true" [text]="true" (click)="$event.stopPropagation(); onDelete.emit(req)"/>
          }
        </td>
    }
    </tr>
  </ng-template>
</p-table>